<template>
<!-- Log period choose -->
<!-- <pick-period-vidget
	class="py-2"
	:tiles="new Array(
		['24 год', 1],
		['7 днів', 7],
		['30 днів', 30],
		['90 днів', 90])"
	@value="(v) => viewDaysFromNow = v"
/> -->

<easy-data-table
	class="data-table"
	table-class-name="customize-table"
	:key="rowsPerPage"
	:headers="tableHeaders"
	:items="tableItems"
	theme-color="rgb(198, 199, 200)"
	sort-by="time"
	sort-type="desc"
	:rows-items="[12,20,50,100]"
	:rows-per-page="rowsPerPage"
	rows-per-page-message="записів на сторінці"
	rows-of-page-separator-message=" з "
	:table-min-height="80"
	:table-height="tableHeight"
	:loading="isLoading"
	:no-hover="true"
	alternating
	buttons-pagination
>
	<!-- If rows is empty -->
	<template #empty-message>
		Записів не знайдено
	</template>

	<template #loading>
		<div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
			<span class="visually-hidden">Loading...</span>
		</div>
	</template>

	<!-- Custom header for active energy by tarifs -->
	<template #[`header-${ElectricMeter.metricKeys.activeEnergyFullApPam}`]="">
		<!-- {{header.text }} -->
		<div class="container text-center">
			<div class="row">
				<div class="col">
					Енергія&nbsp;по&nbsp;тарифам,&nbsp;кВт⋅год
				</div>
			</div>
			<div class="row">
				<div class="col">Тариф&nbsp;1</div>
				<div class="col">Тариф&nbsp;2</div>
				<div class="col">Тариф&nbsp;3</div>
				<div class="col">Тариф&nbsp;4</div>
			</div>
		</div>
    </template>

	<!-- Time item customization -->
	<template #item-time="{ time }">
		{{ dateTimeToDateString(time, false) }}
	</template>

	<!-- Custom item for active energy by tarifs -->
	<template #[`item-${ElectricMeter.metricKeys.fullActiveEnergy}`]="item">
		{{ fixNumberPrecision(item[ElectricMeter.metricKeys.fullActiveEnergy], 1) }}
	</template>

	<!-- Custom item for month energy -->
	<template #item-monthEnergy="item">
		<div class="cell-progress-wrapper">
			<div class="progress m-0" role="progressbar">
				<div
					class="progress-bar text-bg-success"
					:style="{ width: (item.monthEnergy / maxMonthEnergy * 100) + '%' }"
				>
					{{ item.monthEnergy }}
				</div>
			</div>
		</div>
	</template>

	<!-- Custom item for active energy by tarifs -->
	<template #[`item-${ElectricMeter.metricKeys.activeEnergyFullApPam}`]="item">
		<div class="container text-center">
			<div class="row">
				<div class="col">{{ numberToKnumber(item[ElectricMeter.metricKeys.activeEnergyFullApPam][0], 1) }}</div>
				<div class="col">{{ numberToKnumber(item[ElectricMeter.metricKeys.activeEnergyFullApPam][1], 1) }}</div>
				<div class="col">{{ numberToKnumber(item[ElectricMeter.metricKeys.activeEnergyFullApPam][2], 1) }}</div>
				<div class="col">{{ numberToKnumber(item[ElectricMeter.metricKeys.activeEnergyFullApPam][3], 1) }}</div>
			</div>
		</div>
	</template>
</easy-data-table>
</template>


<script>
import {
	subtractHoursFromNowDate,
	//dateTimeToString,
	fixNumberPrecision,
	dateTimeToDateString,
	numberToKnumber,
	easyDataTableHeight,
	easyDataTableRowsPerPage,
} from '@/helpers.js'
//import PickPeriodVidget from '@/components/Vidgets/PickPeriodVidget.vue'
import { useAccontStore } from '@/stores/AccountStore'
import { useStationsStore } from '@/stores/StationsStore.js'
import { Station } from '@/models/station.js'
import { ElectricMeter } from '@/models/electricMeter.js'
import { ServiceUnit } from '@/models/serviceUnit.js'
import { readExternalElecticMeterReportTable, readServiceUnitElecticMeterReportTable } from '@/api/api.js'

export default {
	viewYears: 5,

	components: {
		//PickPeriodVidget,
	},

	props: {
		stationId: {
			type: String,
			require: true,
		},
	},

	setup() {
		const accountStore = useAccontStore()
		const stationsStore = useStationsStore()

		return {
			accountStore,
			stationsStore,
			fixNumberPrecision,
			numberToKnumber,
			dateTimeToDateString,
			easyDataTableHeight,
			easyDataTableRowsPerPage,
			ElectricMeter,
		}
	},

	data() {
		return {
			// For table period from. Hours from now.
			//viewDaysFromNow: 1,
			isLoading: true,
			// Table
			rowsPerPage: 20,
			tableHeaders:[],
			tableItems: [],
		}
	},

	watch: {
		isPresentActiveEnergyTarifs(newValues) {
			if (newValues) {
				this.tableHeaders.push({ text: "Енергія по тарифам 1-4, кВт⋅год", value: ElectricMeter.metricKeys.activeEnergyFullApPam, })
			}
			// console.log('this.tableHeaders', this.tableHeaders)
		}
	},

	async created() {
		if ([
				ElectricMeter.versions.nikDlms,
				ElectricMeter.versions.gama100G1m,
				ElectricMeter.versions.gama100G1b
			].includes(this.station.passport.get(Station.passportKeys.electricMeter.self)?.type)
		) {
			await this.readTableRowFromExternalElectricMeter()
		} else if(this.station.passport.get(Station.passportKeys.electricMeter.self)?.type == ElectricMeter.versions.impulseInput) {
			await this.readTableRowFromServiceUnit()
		}

		// Create table headers
		this.tableHeaders.push({ text: "Часовий період", value: "time", sortable: true, width: 160, })
		this.tableHeaders.push({ text: "Повна енергія (активна), кВт⋅год", value: ElectricMeter.metricKeys.fullActiveEnergy, })
		this.tableHeaders.push({ text: "Спожито за період, кВт⋅год", value: 'monthEnergy', })
		if (this.isPresentActiveEnergyTarifs) {
			this.tableHeaders.push({ text: "Енергія по тарифам 1-4, кВт⋅год", value: ElectricMeter.metricKeys.activeEnergyFullApPam, })
		}

		// Format table rows
		this.tableItems.forEach((row, index, array) => {
			// Make time on last month day not first (substract some time)
			row["time"] = new Date(row["time"].getTime() - 1000 * 60 * 60 * 4)

			// Calculate month energy
			if (array[index - 1]) {
				row['monthEnergy'] = Number(
					row[ElectricMeter.metricKeys.fullActiveEnergy]
					- array[index - 1][ElectricMeter.metricKeys.fullActiveEnergy]
				)

				if (isNaN(row['monthEnergy'])) {
					row['monthEnergy'] = undefined
				} else if (row['monthEnergy'] < 0) {
					row['monthEnergy'] = undefined
				} else if (row['monthEnergy'] >= 0) {
					row['monthEnergy'] = row['monthEnergy'].toFixed(1)
				} else {
					row['monthEnergy'] = undefined
				}
			}
		})
	},

	mounted() {
		this.rowsPerPage = easyDataTableRowsPerPage(this.tableHeight)
	},

	methods: {
		async readTableRowFromServiceUnit() {
			let rows = Array()

			this.isLoading = true
			await readServiceUnitElecticMeterReportTable(this.station.passport.get(Station.passportKeys.metricsId),
				subtractHoursFromNowDate(this.$options.viewYears * 365 * 24),
				new Date(),
				rows
			)
			//console.log("Table rows raw", rows)

			if (rows.length == 0) {
				this.tableItems.length = 0
				this.isLoading = false
				return
			}

			// Prepare rows for table
			//rows.pop()	// delete last (not full month) metric
			rows.forEach((row) => {
				// Make sumarized energy and translate to KWats*hour
				row[ElectricMeter.metricKeys.activeEnergyFullApPam] = ['-','-','-','-',]
				row[ElectricMeter.metricKeys.fullActiveEnergy] = row[ServiceUnit.metricKeys.extPwrCounterEnergy]
				if (row[ElectricMeter.metricKeys.fullActiveEnergy]) {
					row[ElectricMeter.metricKeys.fullActiveEnergy] = row[ElectricMeter.metricKeys.fullActiveEnergy].toFixed(0)
				} else {
					row[ElectricMeter.metricKeys.fullActiveEnergy] = "-"
				}
			})

			this.tableItems.length = 0
			this.tableItems = rows
			this.isLoading = false
		},

		async readTableRowFromExternalElectricMeter() {
			let rows = Array()
			
			this.isLoading = true
			// Read table rows
			await readExternalElecticMeterReportTable(
				this.station.passport.get(Station.passportKeys.metricsId),
				subtractHoursFromNowDate(this.$options.viewYears * 365 * 24),
				new Date(),
				rows
			)
			//console.log("Table rows raw", rows)

			if (rows.length == 0) {
				this.tableItems.length = 0
				this.isLoading = false
				return
			}

			// Prepare rows for table
			rows.pop()	// delete last (not full month) metric
			rows.forEach((row) => {
				// null values -> "-"
				Object.entries(row).forEach(([key, value]) => {
					if (value == null) {
						row[key] = "-"
					}
				})

				// Make sumarized energy and translate to KWats*hour
				row[ElectricMeter.metricKeys.activeEnergyFullApPam] = [
					row[`${ElectricMeter.metricKeys.activeEnergyFullApPam}_1`],
					row[`${ElectricMeter.metricKeys.activeEnergyFullApPam}_2`],
					row[`${ElectricMeter.metricKeys.activeEnergyFullApPam}_3`],
					row[`${ElectricMeter.metricKeys.activeEnergyFullApPam}_4`],
				]
			})

			this.tableItems.length = 0
			this.tableItems = rows
			this.isLoading = false
		},
	},

	computed: {
		station() {return this.stationsStore.station(this.stationId) },

		tableHeight() {
			return easyDataTableHeight() - 325
		},

		isPresentActiveEnergyTarifs() {
			return this.station.electricMeter.isPresentActiveEnergyTarifs
		},

		minMonthEnergy() {
			return Math.min(
				... this.tableItems.map(
					(row) => row['monthEnergy']
				).filter((v) => !isNaN(Number(v)))
			)
		},

		maxMonthEnergy() {
			return Math.max(
				... this.tableItems.map(
					(row) => row['monthEnergy']
				).filter((v) => !isNaN(Number(v)))
			)
		},
	},
}
</script>


<style src="@/assets/table.css" scoped></style>
<style scoped>
/* td make relative-container */
.easy-data-table td {
	position: relative;
}

/* wrpper fills td */
.cell-progress-wrapper {
	position: absolute;
	inset: 0; /* top:0; right:0; bottom:0; left:0 */
	padding-top: 1px !important;
	padding-bottom: 1px !important;
}

/* strach progress bar */
.cell-progress-wrapper .progress {
	width: 100%;
	height: 100% !important;  /* перебиває bootstrap */
	margin: 0 !important;
}

.progress {
	background-color: transparent !important;
}

.progress,
.progress-bar {
	border-radius: 0 !important;
}

.text-bg-success {
	background-color: RGBA(115, 191, 105, 0.75) !important;
	font-size: var(--easy-table-body-row-font-size);
	color: var(--easy-table-body-row-font-color) !important;
}
</style>